// extracted by mini-css-extract-plugin
module.exports = {"row":"LogoWallRow_row___NlgR","duplicate":"LogoWallRow_duplicate__h1Wun","icon":"LogoWallRow_icon__J0ork"};